export default {
  license_definition: [],
  having_license: [],
};

